import React, { useEffect, useMemo, useState } from 'react';
import Portal from '../../../../../UI/Portal/Portal';
import { Widgets } from '../Widgets/Widgets';
import { Link } from 'react-router-dom';
import ProductRecommendations from '../Widgets/ProductRecommendations/ProductRecommendations';
import { resizeMap } from '../../../../../../util/imageMaps';
import useFacet from '../../../../../Hooks/Shared/Facet/useFacet';
import useSelectedFacetsByType from '../../../../../Hooks/Shared/Facet/useSelectedFacetsByType';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';

const _unbindFacetClicks = () => {
  $('.facet-title').off('click.toggle');
  $('.facet li a').off('click.hideLeaf');
};

const removeCookieScrolled = (sidebarNav) => {
  if (sidebarNav.classList.contains('sidebar-cookie-scrolled')) {
    sidebarNav.classList.remove('sidebar-cookie-scrolled');
  }
};

const removeCookieUnscrolled = (sidebarNav) => {
  if (sidebarNav.classList.contains('sidebar-cookie-unscrolled')) {
    sidebarNav.classList.remove('sidebar-cookie-unscrolled');
  }
};

const removeScrolled = (sidebarNav) => {
  if (sidebarNav.classList.contains('sidebar-scrolled')) {
    sidebarNav.classList.remove('sidebar-scrolled');
  }
};

const removeUnscrolled = (sidebarNav) => {
  if (sidebarNav.classList.contains('sidebar-unscrolled')) {
    sidebarNav.classList.remove('sidebar-unscrolled');
  }
};

const _handleFacetClick = () => {
  $('.facet-title').on('click.toggle', function (e) {
    $(this).toggleClass('open');
  });

  $('.facet li a').on('click.hideLeaf', function () {
    var el = document.getElementsByClassName('facet-title');
    for (var i = 0; i < el.length; i++) {
      if (el[i] !== null && el[i].getAttribute('data-isleaflevel') === 'true') {
        el[i].nextElementSibling.style.display = 'none';
        el[i].style.display = 'none';
      } else if (el[i] !== null && el[i].getAttribute('data-isleaflevel') === 'false') {
        el[i].nextElementSibling.style.display = 'block';
        el[i].style.display = 'block';
      }
    }
    if (document.querySelector('.desktopPage')) {
      document.documentElement.scrollTop = 0;
    }
  });
};

export function NavigationTemplate(props) {
  const [showFacetMenu, setShowFacetMenu] = useState(false);
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [currentPathname, setCurrentPathname] = useState('');

  const toggleFacetMenu = () => {
    setShowFacetMenu((showFacetMenu) => !showFacetMenu);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const toggleSortMenu = () => {
    setShowSortMenu((showSortMenu) => !showSortMenu);
  };

  const handleStickySidebar = () => {
    var sidebarNav = document.getElementById('sidebar');
    const position = window.pageYOffset;
    if (position > 173) {
      if (
        document.getElementById('onetrust-banner-sdk') &&
        document.getElementById('onetrust-banner-sdk').style.display != 'none'
      ) {
        // Scrolled & Cookie Banner Visible
        // Add sidebar-cookie-scrolled if not present
        if (!sidebarNav.classList.contains('sidebar-cookie-scrolled')) {
          sidebarNav.classList.add('sidebar-cookie-scrolled');
        }
        // Remove other classes if present
        removeCookieUnscrolled(sidebarNav);
        removeScrolled(sidebarNav);
        removeUnscrolled(sidebarNav);
      } else {
        // Scrolled & Cookie Banner Not Present or Visible
        // Add sidebar-scrolled if not present
        if (!sidebarNav.classList.contains('sidebar-scrolled')) {
          sidebarNav.classList.add('sidebar-scrolled');
        }
        // Remove other classes if present
        removeCookieScrolled(sidebarNav);
        removeCookieUnscrolled(sidebarNav);
        removeUnscrolled(sidebarNav);
      }
    } else {
      if (
        document.getElementById('onetrust-banner-sdk') &&
        document.getElementById('onetrust-banner-sdk').style.display != 'none'
      ) {
        // Unscrolled & Cookie Banner Visible
        // Add sidebar-cookie-unscrolled if not present
        if (!sidebarNav.classList.contains('sidebar-cookie-unscrolled')) {
          sidebarNav.classList.add('sidebar-cookie-unscrolled');
        }
        // Remove other classes if present
        removeCookieScrolled(sidebarNav);
        removeScrolled(sidebarNav);
        removeUnscrolled(sidebarNav);
      } else {
        // Unscrolled & Cookie Banner Not Present or Visible
        // Add sidebar-cookie-scrolled if not present
        if (!sidebarNav.classList.contains('sidebar-unscrolled')) {
          sidebarNav.classList.add('sidebar-unscrolled');
        }
        // Remove other classes if present
        removeCookieScrolled(sidebarNav);
        removeCookieUnscrolled(sidebarNav);
        removeScrolled(sidebarNav);
      }
    }
  };

  const { siteFormat } = props.passedAppFunctions;

  useEffect(() => {
    showFacetMenu ? $('body').addClass('filter-open') : $('body').removeClass('filter-open');
    showSortMenu ? $('body').addClass('sort-open') : $('body').removeClass('sort-open');
    _unbindFacetClicks();
    _handleFacetClick();

    if (siteFormat === 'desktop' && document.getElementById('sidebar')) {
      var pathnameToCheck = location.pathname.substring(location.pathname.indexOf('/c/') + 3).split('/')[0];

      if (pathnameToCheck !== currentPathname) {
        document.getElementById('sidebar').scrollTop = 0;
        setCurrentPathname(pathnameToCheck);
      }
    }
    // WWW-22322 - until we can refactor
    if (props.layoutContent.resultListIsPresent === 'false' && siteFormat === 'tablet') {
      setTimeout(() => {
        _unbindFacetClicks();
        _handleFacetClick();
      }, 1000);
    }
  }, [currentPathname, showFacetMenu, showSortMenu, siteFormat, props.layoutContent.resultListIsPresent]);

  useEffect(() => {
    if (siteFormat === 'desktop' && props.layoutContent.resultListIsPresent) {
      setCurrentPathname(location.pathname.substring(location.pathname.indexOf('/c/') + 3).split('/')[0]);
    }

    if (siteFormat === 'desktop') {
      window.addEventListener('scroll', handleStickySidebar);
    }
    props.passedAppFunctions.lazyObserver();
    _handleFacetClick();
    /**
     * If content contains a carousel with a useMap on first image, initialize the map.
     **/
    resizeMap();
    const wrapperSize = _.debounce(resizeMap, 400);
    window.addEventListener('load', wrapperSize);
    window.addEventListener('resize', wrapperSize);

    return () => {
      $('body').removeClass('filter-open');
      $('body').removeClass('sort-open');
      _unbindFacetClicks();
      window.removeEventListener('load', wrapperSize);
      window.removeEventListener('resize', wrapperSize);
      if (siteFormat === 'desktop') {
        window.removeEventListener('scroll', handleStickySidebar);
      }
    };
  }, []);

  var newArrivalsWidgetIsPresent = false;
  var shopSaleWidgetIsPresent = false;
  const facetIsPresent = [];
  const customJFYChecked = props.passedAppFunctions.getURLParamValue('justForYou') === '1';
  const storedIsInternational = props.passedAppFunctions.isInternational();
  for (var i = 1; i <= 9; i++) {
    var thisSlotData = props.layoutContent.slots[i + ''];
    for (var j = 0; j < thisSlotData.widgets.length; j++) {
      var thisWidget = thisSlotData.widgets[j];
      if (thisWidget.widgetType == 'ShopNewArrivals') {
        newArrivalsWidgetIsPresent = true;
      }
      if (thisWidget.widgetType == 'ShopSale') {
        shopSaleWidgetIsPresent = true;
      }
      if (thisWidget.widgetType == 'FacetLocationTitle') {
        facetIsPresent.push(thisWidget.facetTitle);
      }
    }
  }
  let facetsJSONExclude = cloneDeep(props.layoutContent.facetsJSON);
  if (props.layoutContent.facetsJSON.facetsList !== undefined) {
    facetsJSONExclude.facetsList = [];
    for (let i = 0; i < props.layoutContent.facetsJSON.facetsList.length; i++) {
      let found = false;
      for (let j = 0; j < facetIsPresent.length; j++) {
        if (
          props.layoutContent.facetsJSON[props.layoutContent.facetsJSON.facetsList[i]].facetTitle.toLowerCase() ===
          facetIsPresent[j].toLowerCase()
        ) {
          found = true;
          break;
        }
      }
      if (!found) {
        facetsJSONExclude.facetsList.push(props.layoutContent.facetsJSON.facetsList[i]);
      }
    }
  }

  var containsBreadcrumbTrail = false;
  var actualBreadCrumb = '';
  var excludeFacets = false;

  var slot = props.layoutContent.slots;
  let includeCriteoAdPlacement = true;
  let criteoSupersToInclude = props.passedAppFunctions.wasParms.criteoSupersToInclude
    ? props.passedAppFunctions.wasParms.criteoSupersToInclude
    : '';

  for (var key in slot) {
    var thisSlot = slot[key].widgets;
    for (i = 0; i < thisSlot.length; i++) {
      if (
        (thisSlot[i].widgetType != 'undefined' && thisSlot[i].widgetType == 'BreadcrumbTrail') ||
        thisSlot[i].breadcrumbItems !== undefined
      ) {
        containsBreadcrumbTrail = true;
        actualBreadCrumb = thisSlot[i].breadcrumbItems;

        // if (actualBreadCrumb.length === 1 && props.passedAppFunctions.contentSwitchPath.indexOf('/search-term/') >= 0) {
        // 	excludeFacets = true;
        // }

        for (let thisBreadcrumb of actualBreadCrumb) {
          if (criteoSupersToInclude.indexOf('|' + thisBreadcrumb.breadcrumbCatId + '|') > -1) {
            includeCriteoAdPlacement = true;
          }
        }
      }

      if (
        !includeCriteoAdPlacement &&
        thisSlot[i]?.widgetType == 'CategoryNavigation' &&
        thisSlot[i]?.categories?.length > 0
      ) {
        for (let thisCategory of thisSlot[i].categories) {
          if (criteoSupersToInclude.indexOf('|' + thisCategory.categoryId + '|') > -1) {
            includeCriteoAdPlacement = true;
          }
        }
      }
    }
  }

  const selectedFacetsByType = useSelectedFacetsByType();

  return (
    <section id='NavigationTemplate'>
      <div className='row template-row'>
        <div className='col-12'>
          <Widgets
            slotNumber={1}
            slotData={props.layoutContent.slots['1']}
            facetsJSON={props.layoutContent.facetsJSON}
            passedAppFunctions={props.passedAppFunctions}
            containsBreadcrumbTrail={containsBreadcrumbTrail}
            excludeFacets={excludeFacets}
          />
          <Widgets
            slotNumber={2}
            slotData={props.layoutContent.slots['2']}
            facetsJSON={props.layoutContent.facetsJSON}
            passedAppFunctions={props.passedAppFunctions}
            containsBreadcrumbTrail={containsBreadcrumbTrail}
            excludeFacets={excludeFacets}
          />
        </div>

        <div className='col-12'>
          <Widgets
            slotNumber={3}
            slotData={props.layoutContent.slots['3']}
            facetsJSON={props.layoutContent.facetsJSON}
            passedAppFunctions={props.passedAppFunctions}
            containsBreadcrumbTrail={containsBreadcrumbTrail}
            excludeFacets={excludeFacets}
          />
        </div>
      </div>

      {siteFormat === 'desktop' ? (
        <div className='row template-row'>
          <div id='sidebar' className='col-sm-2 aside-facets-column sticky-sidebar' aria-label='sidebar' role='region'>
            <div className='layout-slot layout-slot-four'></div>
            <Widgets
              newArrivalsWidgetIsPresent={newArrivalsWidgetIsPresent}
              shopSaleWidgetIsPresent={shopSaleWidgetIsPresent}
              resultListIsPresent={props.layoutContent.resultListIsPresent}
              slotNumber={4}
              containsBreadcrumbTrail={containsBreadcrumbTrail}
              excludeFacets={excludeFacets}
              slotData={props.layoutContent.slots['4']}
              facetsJSONAll={props.layoutContent.facetsJSON}
              facetsJSON={facetsJSONExclude}
              passedAppFunctions={props.passedAppFunctions}
            />
            <div className='layout-slot layout-slot-five'></div>
            <Widgets
              newArrivalsWidgetIsPresent={newArrivalsWidgetIsPresent}
              shopSaleWidgetIsPresent={shopSaleWidgetIsPresent}
              resultListIsPresent={props.layoutContent.resultListIsPresent}
              slotNumber={5}
              containsBreadcrumbTrail={containsBreadcrumbTrail}
              excludeFacets={excludeFacets}
              slotData={props.layoutContent.slots['5']}
              facetsJSONAll={props.layoutContent.facetsJSON}
              facetsJSON={facetsJSONExclude}
              passedAppFunctions={props.passedAppFunctions}
            />
            <div className='layout-slot layout-slot-six'></div>
            <Widgets
              newArrivalsWidgetIsPresent={newArrivalsWidgetIsPresent}
              shopSaleWidgetIsPresent={shopSaleWidgetIsPresent}
              resultListIsPresent={props.layoutContent.resultListIsPresent}
              slotNumber={6}
              containsBreadcrumbTrail={containsBreadcrumbTrail}
              excludeFacets={excludeFacets}
              slotData={props.layoutContent.slots['6']}
              facetsJSONAll={props.layoutContent.facetsJSON}
              facetsJSON={facetsJSONExclude}
              passedAppFunctions={props.passedAppFunctions}
            />
            <div className='layout-slot layout-slot-seven'></div>
            <Widgets
              newArrivalsWidgetIsPresent={newArrivalsWidgetIsPresent}
              shopSaleWidgetIsPresent={shopSaleWidgetIsPresent}
              resultListIsPresent={props.layoutContent.resultListIsPresent}
              slotNumber={7}
              containsBreadcrumbTrail={containsBreadcrumbTrail}
              excludeFacets={excludeFacets}
              slotData={props.layoutContent.slots['7']}
              facetsJSONAll={props.layoutContent.facetsJSON}
              facetsJSON={facetsJSONExclude}
              passedAppFunctions={props.passedAppFunctions}
            />
          </div>
          {!customJFYChecked ? (
            <div className='col-sm-10 results-column'>
              <div className='layout-slot layout-slot-eight'></div>
              <Widgets
                slotNumber={8}
                containsBreadcrumbTrail={containsBreadcrumbTrail}
                excludeFacets={excludeFacets}
                slotData={props.layoutContent.slots['8']}
                facetsJSON={props.layoutContent.facetsJSON}
                passedAppFunctions={props.passedAppFunctions}
                resultListIsPresent={props.layoutContent.resultListIsPresent}
              />
              <div className='layout-slot layout-slot-nine'></div>
              <Widgets
                slotNumber={9}
                containsBreadcrumbTrail={containsBreadcrumbTrail}
                excludeFacets={excludeFacets}
                slotData={props.layoutContent.slots['9']}
                facetsJSON={props.layoutContent.facetsJSON}
                passedAppFunctions={props.passedAppFunctions}
                resultListIsPresent={props.layoutContent.resultListIsPresent}
                actualBreadCrumb={actualBreadCrumb}
                includeCriteoAdPlacement={includeCriteoAdPlacement}
                selectedFacetsByType={selectedFacetsByType}
              />
            </div>
          ) : (
            <div className='col-sm-10 results-column'>
              <div className='col-sm-12 col-sm-12 col-md-12 col-lg-12'>
                <div className='alert alert-danger nav-alert m-t-15' role='alert'>
                  No products were found that match this criteria.
                </div>
              </div>
              {!storedIsInternational && (
                <div className='col-sm-12 col-sm-12 col-md-12 col-lg-12'>
                  <div className='alert alert-info nav-alert m-t-15' role='alert'>
                    Share your style preferences with us for a tailored shopping experience Just For You.
                    <div className='underline'>
                      <Link to={'/my-preferences'} rel='nofollow'>
                        Edit My Preferences
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <>
          <Portal>
            <div className={`FilterPortal ${showFacetMenu ? 'opened' : ''}`}>
              <FilterMenuTablet
                showFacetMenu={showFacetMenu}
                toggleFacetMenu={toggleFacetMenu}
                facetsJSONAll={props.layoutContent.facetsJSON}
                facetsJSON={facetsJSONExclude}
                passedAppFunctions={props.passedAppFunctions}
                layoutContent={props.layoutContent}
                newArrivalsWidgetIsPresent={newArrivalsWidgetIsPresent}
                shopSaleWidgetIsPresent={shopSaleWidgetIsPresent}
                resultListIsPresent={props.layoutContent.resultListIsPresent}
              />
            </div>
          </Portal>
          {/* </If> */}

          <div className='row template-row'>
            <div className='col-sm-12 results-column'>
              {siteFormat == 'tablet' && !customJFYChecked && (
                <Widgets
                  slotNumber={8}
                  slotData={props.layoutContent.slots['8']}
                  facetsJSON={props.layoutContent.facetsJSON}
                  passedAppFunctions={props.passedAppFunctions}
                  resultListIsPresent={props.layoutContent.resultListIsPresent}
                />
              )}
              {/* tablet filter-sort */}

              {(siteFormat == 'tablet' && props.layoutContent.resultListIsPresent == 'false') || customJFYChecked ? (
                <div className='col-3 filter-sort-row noResultsFilter'>
                  <button className='btn btn-grey btn-filter' type='button' onClick={toggleFacetMenu}>
                    Filter<i className='icon i-arrow-down'></i>
                  </button>
                </div>
              ) : null}
              {siteFormat == 'tablet' && !customJFYChecked && (
                <Widgets
                  slotNumber={9}
                  slotData={props.layoutContent.slots['9']}
                  facetsJSON={props.layoutContent.facetsJSON}
                  passedAppFunctions={props.passedAppFunctions}
                  resultListIsPresent={props.layoutContent.resultListIsPresent}
                  toggleFacetMenu={toggleFacetMenu}
                  toggleSortMenu={toggleSortMenu}
                  showSortMenu={showSortMenu}
                  actualBreadCrumb={actualBreadCrumb}
                  includeCriteoAdPlacement={includeCriteoAdPlacement}
                  selectedFacetsByType={selectedFacetsByType}
                />
              )}
            </div>
          </div>

          {siteFormat === 'tablet' && customJFYChecked && (
            <div className='row template-row'>
              <div className='col-sm-12 col-sm-12 col-md-12 col-lg-12'>
                <div className='alert alert-danger nav-alert m-t-15' role='alert'>
                  No products were found that match this criteria.
                </div>
              </div>
              {!storedIsInternational && (
                <div className='col-sm-12 col-sm-12 col-md-12 col-lg-12'>
                  <div className='alert alert-info nav-alert m-t-15' role='alert'>
                    Share your style preferences with us for a tailored shopping experience Just For You.
                    <div className='underline'>
                      <Link to={'/my-preferences'} rel='nofollow'>
                        Edit My Preferences
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}

      {/* <div className={`results-column ${siteFormat == "desktop" ? 'col-sm-10 col-md-10 col-lg-10' : 'col-sm-12 col-md-12 col-lg-12' }`}>
                    <Widgets slotNumber={8} slotData={props.layoutContent.slots['8']} facetsJSON={props.layoutContent.facetsJSON} passedAppFunctions={props.passedAppFunctions} />
                    <Widgets slotNumber={9} slotData={props.layoutContent.slots['9']} facetsJSON={props.layoutContent.facetsJSON} passedAppFunctions={props.passedAppFunctions} />
                </div> */}
      {props.layoutContent.resultListIsPresent == 'true' && (
        <div className='template-row'>
          <div className='recentlyViewedContainer'>
            <ProductRecommendations
              widgetData={{
                zone: 'RecentlyViewed',
                scrollable: true,
                rows: 1,
                productsPerRow: 6,
                showProductTitle: true,
                title: 'Recently Viewed',
              }}
              passedAppFunctions={props.passedAppFunctions}
            />
          </div>
        </div>
      )}
    </section>
  );
}

function SelectedFacets(props) {
  const { getFacetNameFromFacetValue, selectedFacets, generateLinkForFacet } = useFacet(props);

  function resetKeepPos() {
    props.passedAppFunctions.setNavigationToggle('keepPos', false);
  }

  if (selectedFacets.length === 0) return null;

  return (
    <div id='selectFilterFacets'>
      <span>
        <Link className='clearAllFilters' to={generateLinkForFacet(false)} onClick={resetKeepPos}>
          clear all
        </Link>
      </span>
      {selectedFacets.map((thisFacetValue) => {
        if (getFacetNameFromFacetValue(thisFacetValue) === 'facet') return;
        return (
          <span className='selectedFilter' key={thisFacetValue}>
            <Link to={generateLinkForFacet(thisFacetValue)}>
              {getFacetNameFromFacetValue(thisFacetValue).split('#double;').join('"').split('%27').join("'")}
              <svg
                role='img'
                aria-labelledby={
                  'clearFilter' +
                  getFacetNameFromFacetValue(thisFacetValue).split('#double;').join('"').split(' ').join('')
                }
                height='10'
                width='10'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 48.77 48.77'
              >
                <title
                  id={
                    'clearFilter' +
                    getFacetNameFromFacetValue(thisFacetValue).split('#double;').join('"').split(' ').join('')
                  }
                >
                  clear filter
                </title>
                <g data-name='Layer 2'>
                  <g data-name='Layer 1'>
                    <path d='M25.8,24.39,48.48,1.71A1,1,0,0,0,47.07.29L24.39,23,1.71.29A1,1,0,0,0,.29,1.71L23,24.39.29,47.07a1,1,0,1,0,1.41,1.41L24.39,25.8,47.07,48.48a1,1,0,0,0,1.41-1.41Z' />
                  </g>
                </g>
              </svg>
            </Link>
          </span>
        );
      })}
    </div>
  );
}

class FilterMenuTablet extends React.Component {
  componentDidMount() {
    this._handleFacetClick();
  }
  componentWillUnmount() {
    this._unbindFacetClicks();
  }

  _handleFacetClick() {
    $('.facet-title').on('click.toggle', function (e) {
      $(this).toggleClass('open');
    });
  }
  _unbindFacetClicks() {
    $('.facet-title').off('click.toggle');
  }
  render() {
    return (
      <React.Fragment>
        <aside
          className={`filter-by-wrapper filter-sort-wrappers ${this.props.showFacetMenu ? 'opened' : ''}`}
          aria-label='sidebar'
          role='region'
        >
          <div className='header-wrapper'>
            <button className='btn btn-secondary' onClick={this.props.toggleFacetMenu}>
              Done
            </button>
          </div>
          <div className='filter-by-content filter-sort-contents'>
            <div className='facet-inner'>
              <SelectedFacets facetsJSON={this.props.facetsJSON} passedAppFunctions={this.props.passedAppFunctions} />
              <Widgets
                newArrivalsWidgetIsPresent={this.props.newArrivalsWidgetIsPresent}
                shopSaleWidgetIsPresent={this.props.shopSaleWidgetIsPresent}
                resultListIsPresent={this.props.resultListIsPresent}
                slotNumber={4}
                slotData={this.props.layoutContent.slots['4']}
                facetsJSONAll={this.props.facetsJSONAll}
                facetsJSON={this.props.facetsJSON}
                passedAppFunctions={this.props.passedAppFunctions}
                toggleFacetMenu={this.props.toggleFacetMenu}
              />
              <Widgets
                newArrivalsWidgetIsPresent={this.props.newArrivalsWidgetIsPresent}
                shopSaleWidgetIsPresent={this.props.shopSaleWidgetIsPresent}
                resultListIsPresent={this.props.resultListIsPresent}
                slotNumber={5}
                slotData={this.props.layoutContent.slots['5']}
                facetsJSONAll={this.props.facetsJSONAll}
                facetsJSON={this.props.facetsJSON}
                passedAppFunctions={this.props.passedAppFunctions}
              />
              <Widgets
                newArrivalsWidgetIsPresent={this.props.newArrivalsWidgetIsPresent}
                shopSaleWidgetIsPresent={this.props.shopSaleWidgetIsPresent}
                resultListIsPresent={this.props.resultListIsPresent}
                slotNumber={6}
                slotData={this.props.layoutContent.slots['6']}
                facetsJSONAll={this.props.facetsJSONAll}
                facetsJSON={this.props.facetsJSON}
                passedAppFunctions={this.props.passedAppFunctions}
              />
              <Widgets
                newArrivalsWidgetIsPresent={this.props.newArrivalsWidgetIsPresent}
                shopSaleWidgetIsPresent={this.props.shopSaleWidgetIsPresent}
                resultListIsPresent={this.props.resultListIsPresent}
                slotNumber={7}
                slotData={this.props.layoutContent.slots['7']}
                facetsJSONAll={this.props.facetsJSONAll}
                facetsJSON={this.props.facetsJSON}
                passedAppFunctions={this.props.passedAppFunctions}
              />
            </div>
          </div>
        </aside>
        <div className='filterWhiteBG'></div>
        <div className='shade' onClick={this.props.toggleFacetMenu}></div>
      </React.Fragment>
    );
  }
}

export default NavigationTemplate;
